import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type UseBannerActionsReturn = ModelHookResult<undefined, { transitionToPreview: () => void }>;

type UseBannerActionsParams = { onPrimaryAction: () => void };

export function useBannerActions({ onPrimaryAction }: UseBannerActionsParams): UseBannerActionsReturn {
	const track = useTracking();

	const transitionToPreview = useCallback(() => {
		void track('sap_create_preview_click', { placement: 'bottom' });
		onPrimaryAction();
	}, [onPrimaryAction, track]);

	return {
		actions: {
			transitionToPreview,
		},
	};
}
